import { Box, AlertIcon, Flex, Typography } from '@iheartjane/reefer';

import { useKioskSpacing } from '@jane/kiosk/hooks';

export const Alert = ({ label }: { label: string }) => {
  const { getKioskSpacing } = useKioskSpacing();

  return (
    <Box
      background="error-light"
      mb={getKioskSpacing(48, 24)}
      mx="auto"
      width="100%"
      borderRadius="sm"
      p={16}
    >
      <Flex alignItems="center" flexDirection="row">
        <AlertIcon color="error-dark" mr={16} size="md" />
        <Typography color="error-dark" variant="body-semibold">
          {label}
        </Typography>
      </Flex>
    </Box>
  );
};
